export default __webpack_public_path__ + "media/icons/chevron-down-6167fdb5.svg";